<style>
.bg-sidenav-theme .sidenav-horizontal-next.disabled {
  color: dimgray !important;
  display: none;
}
.bg-sidenav-theme .sidenav-horizontal-prev.disabled {
  color: dimgray !important;
  display: none;
}
/*
    Sağ Tema Değiştirme Kapatmak için
  */
#theme-settings .theme-settings-open-btn {
  display: none !important;
}

.cursor-pointer {
  cursor: pointer !important;
}
</style>
<template>
  <div id="app" style="transform: translate3d(0px, 0px, 0px); overflow: hidden">
    <router-view />
  </div>
</template>

<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo() {
    let title = '';
    if (this.$store.getters.generic.settings && this.$store.getters.generic.settings.title) {
      title = this.$store.getters.generic.settings.title;
    }
    if (title === '') {
      title = ``;
    } else {
      title = `${title} - %s`;
    }
    return {
      titleTemplate: title,
    };
  },
  created() {
    let theme = localStorage.getItem('themeSettingsTheme');
    if (!theme || theme !== 'theme-cotton') {
      localStorage.setItem('themeSettingsTheme', 'theme-cotton');
      location.reload();
    }
  },
  updated() {
    setTimeout(() => document.body.classList.remove('app-loading'), 1);
  },
};
</script>

<style src="@/vendor/libs/vue-flatpickr-component/vue-flatpickr-component.scss" lang="scss"></style>
